/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { BooleanDTO } from '../models';
// @ts-ignore
import { Mandant } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * MandantService - axios parameter creator
 * @export
 */
export const MandantServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert ob der Mandant gerade eingeloggten Users die Auftragsvorlagen bearbeiten darf.
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canEditAuftragsvorlage: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mandanten/auftragsvorlage-edit`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMandanten: async (searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getAllMandanten', 'searchString', searchString)
            const localVarPath = `/api/mandanten/allmandanten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreieMandanten: async (searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getFreieMandanten', 'searchString', searchString)
            const localVarPath = `/api/mandanten/freiemandanten`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Hauptmandanten
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHauptmandanten: async (searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getHauptmandanten', 'searchString', searchString)
            const localVarPath = `/api/mandanten/hauptmandanten-list`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert einen Mandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantById: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMandantById', 'id', id)
            const localVarPath = `/api/mandanten/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantSumarriesByHauptmandant: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mandanten/hauptmandant-summary`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantenByHauptmandant: async (id: number, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getMandantenByHauptmandant', 'id', id)
            const localVarPath = `/api/mandanten/hauptmandant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Mandanten
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantenByHauptmandant1: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mandanten/hauptmandant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUntermandanten: async (id: number, searchString: string, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getUntermandanten', 'id', id)
            // verify required parameter 'searchString' is not null or undefined
            assertParamExists('getUntermandanten', 'searchString', searchString)
            const localVarPath = `/api/mandanten/untermandant/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (searchString !== undefined) {
                localVarQueryParameter['searchString'] = searchString;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert ob der Mandant ein Hauptmandant ist oder nicht
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isHauptmandant: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/mandanten/is-hauptmandant`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Widerruft die Hauptmandanten-Berechtigung aus den angegebenen Mandanten
         * @summary Mandant
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterHauptmandanten: async (ids: Array<number>, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'ids' is not null or undefined
            assertParamExists('unregisterHauptmandanten', 'ids', ids)
            const localVarPath = `/api/mandanten/hauptmandant/unregister`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (ids) {
                localVarQueryParameter['ids'] = ids;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Aktualisiert einen bestehenden Mandanten
         * @summary Mandant
         * @param {number} id 
         * @param {Mandant} mandant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMandant: async (id: number, mandant: Mandant, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateMandant', 'id', id)
            // verify required parameter 'mandant' is not null or undefined
            assertParamExists('updateMandant', 'mandant', mandant)
            const localVarPath = `/api/mandanten/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PUT', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(mandant, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MandantService - functional programming interface
 * @export
 */
export const MandantServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = MandantServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert ob der Mandant gerade eingeloggten Users die Auftragsvorlagen bearbeiten darf.
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async canEditAuftragsvorlage(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.canEditAuftragsvorlage(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getAllMandanten(searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getAllMandanten(searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getFreieMandanten(searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getFreieMandanten(searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Hauptmandanten
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getHauptmandanten(searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getHauptmandanten(searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert einen Mandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMandantById(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Mandant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMandantById(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMandantSumarriesByHauptmandant(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMandantSumarriesByHauptmandant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMandantenByHauptmandant(id: number, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMandantenByHauptmandant(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Mandanten
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getMandantenByHauptmandant1(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getMandantenByHauptmandant1(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getUntermandanten(id: number, searchString: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Mandant>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getUntermandanten(id, searchString, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert ob der Mandant ein Hauptmandant ist oder nicht
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async isHauptmandant(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.isHauptmandant(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Widerruft die Hauptmandanten-Berechtigung aus den angegebenen Mandanten
         * @summary Mandant
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async unregisterHauptmandanten(ids: Array<number>, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BooleanDTO>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.unregisterHauptmandanten(ids, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Aktualisiert einen bestehenden Mandanten
         * @summary Mandant
         * @param {number} id 
         * @param {Mandant} mandant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateMandant(id: number, mandant: Mandant, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Mandant>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateMandant(id, mandant, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * MandantService - factory interface
 * @export
 */
export const MandantServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = MandantServiceFp(configuration)
    return {
        /**
         * Liefert ob der Mandant gerade eingeloggten Users die Auftragsvorlagen bearbeiten darf.
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        canEditAuftragsvorlage(options?: any): AxiosPromise<BooleanDTO> {
            return localVarFp.canEditAuftragsvorlage(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getAllMandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getAllMandanten(searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getFreieMandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getFreieMandanten(searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Hauptmandanten
         * @summary Mandant
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getHauptmandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getHauptmandanten(searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert einen Mandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantById(id: number, options?: any): AxiosPromise<Mandant> {
            return localVarFp.getMandantById(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantSumarriesByHauptmandant(options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getMandantSumarriesByHauptmandant(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantenByHauptmandant(id: number, options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getMandantenByHauptmandant(id, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Mandanten
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getMandantenByHauptmandant1(options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getMandantenByHauptmandant1(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert alle Mandanten für einen Hauptmandant
         * @summary Mandant
         * @param {number} id 
         * @param {string} searchString 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getUntermandanten(id: number, searchString: string, options?: any): AxiosPromise<Array<Mandant>> {
            return localVarFp.getUntermandanten(id, searchString, options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert ob der Mandant ein Hauptmandant ist oder nicht
         * @summary Mandant
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        isHauptmandant(options?: any): AxiosPromise<BooleanDTO> {
            return localVarFp.isHauptmandant(options).then((request) => request(axios, basePath));
        },
        /**
         * Widerruft die Hauptmandanten-Berechtigung aus den angegebenen Mandanten
         * @summary Mandant
         * @param {Array<number>} ids 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        unregisterHauptmandanten(ids: Array<number>, options?: any): AxiosPromise<BooleanDTO> {
            return localVarFp.unregisterHauptmandanten(ids, options).then((request) => request(axios, basePath));
        },
        /**
         * Aktualisiert einen bestehenden Mandanten
         * @summary Mandant
         * @param {number} id 
         * @param {Mandant} mandant 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateMandant(id: number, mandant: Mandant, options?: any): AxiosPromise<Mandant> {
            return localVarFp.updateMandant(id, mandant, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MandantService - interface
 * @export
 * @interface MandantService
 */
export interface MandantServiceInterface {
    /**
     * Liefert ob der Mandant gerade eingeloggten Users die Auftragsvorlagen bearbeiten darf.
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    canEditAuftragsvorlage(options?: any): AxiosPromise<BooleanDTO>;

    /**
     * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getAllMandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getFreieMandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert alle Hauptmandanten
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getHauptmandanten(searchString: string, options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert einen Mandant
     * @summary Mandant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getMandantById(id: number, options?: any): AxiosPromise<Mandant>;

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getMandantSumarriesByHauptmandant(options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getMandantenByHauptmandant(id: number, options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert eine Liste von Mandanten
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getMandantenByHauptmandant1(options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {number} id 
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    getUntermandanten(id: number, searchString: string, options?: any): AxiosPromise<Array<Mandant>>;

    /**
     * Liefert ob der Mandant ein Hauptmandant ist oder nicht
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    isHauptmandant(options?: any): AxiosPromise<BooleanDTO>;

    /**
     * Widerruft die Hauptmandanten-Berechtigung aus den angegebenen Mandanten
     * @summary Mandant
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    unregisterHauptmandanten(ids: Array<number>, options?: any): AxiosPromise<BooleanDTO>;

    /**
     * Aktualisiert einen bestehenden Mandanten
     * @summary Mandant
     * @param {number} id 
     * @param {Mandant} mandant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantServiceInterface
     */
    updateMandant(id: number, mandant: Mandant, options?: any): AxiosPromise<Mandant>;

}

/**
 * MandantService - object-oriented interface
 * @export
 * @class MandantService
 * @extends {BaseAPI}
 */
export class MandantService extends BaseAPI implements MandantServiceInterface {
    /**
     * Liefert ob der Mandant gerade eingeloggten Users die Auftragsvorlagen bearbeiten darf.
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public canEditAuftragsvorlage(options?: any) {
        return MandantServiceFp(this.configuration).canEditAuftragsvorlage(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getAllMandanten(searchString: string, options?: any) {
        return MandantServiceFp(this.configuration).getAllMandanten(searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Mandanten die weder Hauptmandant sind, noch einem Hauptmandant zugeordnet sind
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getFreieMandanten(searchString: string, options?: any) {
        return MandantServiceFp(this.configuration).getFreieMandanten(searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Hauptmandanten
     * @summary Mandant
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getHauptmandanten(searchString: string, options?: any) {
        return MandantServiceFp(this.configuration).getHauptmandanten(searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert einen Mandant
     * @summary Mandant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getMandantById(id: number, options?: any) {
        return MandantServiceFp(this.configuration).getMandantById(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getMandantSumarriesByHauptmandant(options?: any) {
        return MandantServiceFp(this.configuration).getMandantSumarriesByHauptmandant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {number} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getMandantenByHauptmandant(id: number, options?: any) {
        return MandantServiceFp(this.configuration).getMandantenByHauptmandant(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Mandanten
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getMandantenByHauptmandant1(options?: any) {
        return MandantServiceFp(this.configuration).getMandantenByHauptmandant1(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert alle Mandanten für einen Hauptmandant
     * @summary Mandant
     * @param {number} id 
     * @param {string} searchString 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public getUntermandanten(id: number, searchString: string, options?: any) {
        return MandantServiceFp(this.configuration).getUntermandanten(id, searchString, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert ob der Mandant ein Hauptmandant ist oder nicht
     * @summary Mandant
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public isHauptmandant(options?: any) {
        return MandantServiceFp(this.configuration).isHauptmandant(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Widerruft die Hauptmandanten-Berechtigung aus den angegebenen Mandanten
     * @summary Mandant
     * @param {Array<number>} ids 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public unregisterHauptmandanten(ids: Array<number>, options?: any) {
        return MandantServiceFp(this.configuration).unregisterHauptmandanten(ids, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Aktualisiert einen bestehenden Mandanten
     * @summary Mandant
     * @param {number} id 
     * @param {Mandant} mandant 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MandantService
     */
    public updateMandant(id: number, mandant: Mandant, options?: any) {
        return MandantServiceFp(this.configuration).updateMandant(id, mandant, options).then((request) => request(this.axios, this.basePath));
    }
}
